import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {SharedPreference} from '../../shared-preference/shared-perference';
import {Role} from '../../model/role';
import {User} from '../../model/user';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';

/** Screen width (px) below which the sidebar behaves as an overlay drawer. */
const MOBILE_BREAKPOINT = 991.98;

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss']
})
export class DefaultComponent implements OnInit, OnDestroy {
  sideBarOpen = true;
  isMobile = false;
  textHasApp: string;
  year: string = new Date().getFullYear().toString();

  private routerEvents$: Subscription;
  private mediaQueryList: any;

  private readonly onMediaQueryChange = (event: any) => {
    this.isMobile = event.matches;
    // Overlay drawer on mobile -> start collapsed, pushed panel on desktop -> open.
    this.sideBarOpen = !this.isMobile;
  };

  constructor(
    public router: Router,
    public http: HttpClient
  ) {}

  ngOnInit() {
    this.textHasApp = '';
    if (this.router.url === '/') {
      this.router.navigate(['/dashboard/dashboard1']);
    }
    this.hasApp();

    // Responsive sidebar: "over" (overlay + backdrop) on mobile, "side" (push) on desktop.
    this.mediaQueryList = window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)');
    this.isMobile = this.mediaQueryList.matches;
    this.sideBarOpen = !this.isMobile;
    if (typeof this.mediaQueryList.addEventListener === 'function') {
      this.mediaQueryList.addEventListener('change', this.onMediaQueryChange);
    } else if (typeof this.mediaQueryList.addListener === 'function') {
      this.mediaQueryList.addListener(this.onMediaQueryChange);
    }

    // Close the overlay drawer automatically after navigating on mobile.
    this.routerEvents$ = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.isMobile && this.sideBarOpen) {
          this.sideBarOpen = false;
        }
      });
  }

  ngOnDestroy(): void {
    if (this.routerEvents$) {
      this.routerEvents$.unsubscribe();
    }
    if (this.mediaQueryList) {
      if (typeof this.mediaQueryList.removeEventListener === 'function') {
        this.mediaQueryList.removeEventListener('change', this.onMediaQueryChange);
      } else if (typeof this.mediaQueryList.removeListener === 'function') {
        this.mediaQueryList.removeListener(this.onMediaQueryChange);
      }
    }
  }

  /** `over` on mobile (covers the page + backdrop), `side` on desktop (pushes content). */
  get drawerMode(): 'over' | 'side' {
    return this.isMobile ? 'over' : 'side';
  }

  sideBarToggler() {
    this.sideBarOpen = !this.sideBarOpen;
  }

  hasApp(){
    if(SharedPreference.getLogin()) {
      if (Role.hasVersitaUser(SharedPreference.getUser())) {
        this.http.get('assets/git-commit-revision.txt', {responseType: 'text'})
          .subscribe(data => this.textHasApp = data);
      }
    }
  }

  isOnHomePage() {
    return this.router.url === "/home-page";
  }

  isOnLoginPage() {
    return this.router.url.includes("/login");
  }

  isOnJoinAsPartner() {
    return this.router.url.includes("/join-as-partner");
  }

  isOnPartnerRegister() {
    return this.router.url.includes("/partner-register");
  }

  getUser() : User{
    return SharedPreference.getUser();
  }
}
